var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { style: { paddingTop: "5px" } },
    [
      _vm._l(_vm.items, function (item, index) {
        return _c("div", { key: index, staticClass: "crm-item" }, [
          _c(
            "div",
            { staticClass: "header" },
            [
              _vm._v(_vm._s(item.adminName)),
              _c("w-spacer"),
              _vm._v(_vm._s(_vm.timestamp(item.timeStamp))),
            ],
            1
          ),
          _c("div", [_vm._v(_vm._s(item.asString))]),
        ])
      }),
      _c(
        "w-col",
        { attrs: { xs: "12" } },
        [
          _c("app-select-discovered-us-from", {
            staticClass: "mt",
            attrs: {
              label: "Winfakt ontdekt via",
              "discovered-us-from": _vm.discoveredUsFrom,
              "empty-text": "Niet ingevuld",
              fancy: "",
            },
          }),
        ],
        1
      ),
      _c(
        "w-col",
        { staticClass: "mt", attrs: { xs: "12" } },
        [
          _c("app-select-company-did-not-purchase-reason", {
            attrs: { fancy: "", label: "Reden van geen aankoop" },
            model: {
              value: _vm.didNotPurchaseReasons,
              callback: function ($$v) {
                _vm.didNotPurchaseReasons = $$v
              },
              expression: "didNotPurchaseReasons",
            },
          }),
        ],
        1
      ),
      _c(
        "w-col",
        { staticClass: "mt", attrs: { xs: "12" } },
        [
          _c("w-textarea", {
            attrs: { label: "Reden van geen aankoop extra", fancy: "" },
            on: { blur: _vm.saveCompany },
            model: {
              value: _vm.didNotPurchaseReasonExplained,
              callback: function ($$v) {
                _vm.didNotPurchaseReasonExplained = $$v
              },
              expression: "didNotPurchaseReasonExplained",
            },
          }),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }